import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import StudioPage from './pages/StudioPage';

import { useAppDispatch, useAppSelector } from './app/hooks';
import {
  selectIsAuthenticated,
  selectTemporaryUserId,
  setTemporaryUserId,
} from './features/auth/authSlice';

function App() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const temporaryUserId = useAppSelector(selectTemporaryUserId);

  useEffect(() => {
    // On startup, ensure there is a temporary user ID for anonymous users.
    // The actual session check for logged-in users is handled by API calls
    // when navigating to protected routes.
    if (!isAuthenticated && !temporaryUserId) {
      const newTemporaryId = uuidv4();
      dispatch(setTemporaryUserId(newTemporaryId));
    }
  }, [dispatch, isAuthenticated, temporaryUserId]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/studio" element={<StudioPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
